import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConstantsService } from 'src/app/constants.service';
import { ReportDownloadDialogComponent } from './report-download-dialog/report-download-dialog.component';
import { AvailableReport, isFlagOn, Report, ReportDownloadDialogData } from './models/report';

@Component({
  selector: 'app-report',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportsComponent {
  readonly sections: Report[];
  selectedSectionIndex = 0;

  private readonly minDate: Date;
  private readonly maxDate: Date;
  private readonly minYearDate: Date;
  private readonly maxYearDate: Date;

  constructor(
    private readonly constantsService: ConstantsService,
    private readonly dialog: MatDialog,
  ) {
    this.sections = (this.constantsService.getConstant('reports') as Report[]) ?? [];

    // Min date is exclusive in the backend, hence the extra day.
    this.minDate = new Date(this.constantsService.getConstant('dateRange.minDate'));
    this.minDate.setDate(this.minDate.getDate() + 1);
    this.maxDate = new Date(this.constantsService.getConstant('dateRange.maxDate'));

    const currentYear = new Date().getFullYear();
    this.minYearDate = new Date(currentYear - 5, 0, 1);
    this.maxYearDate = new Date(currentYear + 1, 11, 31);
  }

  get selectedSection(): Report | undefined {
    return this.sections[this.selectedSectionIndex];
  }

  selectSection(index: number): void {
    this.selectedSectionIndex = index;
  }

  formatOf(report: AvailableReport): string {
    return (report.downloadFormat || 'csv').toUpperCase();
  }

  inputsLabel(report: AvailableReport): string {
    const start = isFlagOn(report.startDt);
    const end = isFlagOn(report.endDt);
    if (!start && !end) return 'No filters';
    if (report.dateRangeType === 'year') return start && end ? 'Year range' : 'Single year';
    return start && end ? 'Date range' : 'Single date';
  }

  openReport(report: AvailableReport): void {
    const data: ReportDownloadDialogData = {
      report,
      minDate: this.minDate,
      maxDate: this.maxDate,
      minYearDate: this.minYearDate,
      maxYearDate: this.maxYearDate,
    };
    this.dialog.open(ReportDownloadDialogComponent, {
      data,
      width: '480px',
      panelClass: 'confirm-dialog-panel',
      autoFocus: false,
      restoreFocus: false,
    });
  }

  trackByName(_: number, report: AvailableReport): string {
    return report.name;
  }
}
